export enum FileStates {
  loading = 'loading',
  error = 'error',
  success = 'success',
}

export enum CodeTypes {
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  SIZE_EXCEEDED = 'SIZE_EXCEEDED',
  VALIDATION_FAILED = 'VALIDATION_FAILED',
  ERROR_INTERNAL = 'ERROR_INTERNAL',
  BAD_REQUEST = 'BAD_REQUEST',
  UNAUTHORIZED = 'UNAUTHORIZED',
  METHOD_NOT_ALLOWED = 'METHOD_NOT_ALLOWED',
  SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',
  BAD_GATEWAY = 'BAD_GATEWAY',
  CONFLICT = 'CONFLICT',
  NOT_FOUND = 'NOT_FOUND',
}

export enum FileNotificationStates {
  delete = 'delete',
  tryLoadAgain = 'tryLoadAgain',
  cancelUpload = 'cancelUpload',
}
